import { createSelector } from 'reselect'

export const getCategoriesWithGroups = createSelector(
  (state) => state && state.categories && state.categories.withGroups && Array.isArray(state.categories.withGroups)
    ? state.categories.withGroups
    : [],
  (categories) => categories
)
